module.exports = __webpack_public_path__ + "img/databao.b4ee2f72.png";